import apiClient from '@/services/api-client';

export default {
	async getAlertNotes(alertId) {
		try {
			const response = await apiClient().get(
				`/Alert/GetNotes?alertId=${alertId}`,
			);
			if (response && response.data) {
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getLeadAlerts(payload) {
		try {
			const response = await apiClient().post('/Alert/GetLeadAlerts', payload);
			if (response && response.data) {
				return Promise.resolve(response.data);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async getAlertTypes() {
		try {
			const response = await apiClient().get('/Alert/GetAllTypes');
			if (response && response.data) {
				// INFO: filtering out "Rate" alert type in search filter due to KEEP go live, may unhide at a later date - Story: B360-3943
				const filteredTypesData = response.data.filter(
					(data) => data.desc !== 'Rate',
				);

				return Promise.resolve(filteredTypesData);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async saveAlertNote(payload) {
		try {
			await apiClient().post('/Alert/InsertNote', payload);
		} catch (error) {
			return Promise.reject(error);
		}
	},
	async updateAlertStatus(payload) {
		try {
			await apiClient().post('/Alert/UpdateStatus', payload);
		} catch (error) {
			return Promise.reject(error);
		}
	},
};
